import { ChatDto, ChatParticipantDto } from '@careapp-group/ng-sdk';
import { createAction, props } from '@ngrx/store';
import { CareAppListActionFactory } from '../action-factory';

class ChatActions extends CareAppListActionFactory<ChatDto> {
  get JOIN_NOW() {
    return `[${this.type}] Join Now`;
  }

  get REQUEST_JOIN() {
    return `[${this.type}][Request] Join Chat`;
  }

  get RESPONSE_SUCCESS_JOIN() {
    return `[${this.type}][Response][Success] Join Chat`;
  }

  get RESPONSE_FAIL_JOIN() {
    return `[${this.type}][Response][Fail] Join Chat`;
  }

  get REQUEST_END() {
    return `[${this.type}][Request] End Chat`;
  }

  get RESPONSE_SUCCESS_END() {
    return `[${this.type}][Response][Success] End Chat`;
  }

  get RESPONSE_FAIL_END() {
    return `[${this.type}][Response][Fail] End Chat`;
  }

  get NOTIFY_NEW_CHAT_AVAILABLE() {
    return `[${this.type}][Notification] New Chat Available`;
  }

  JoinNow = createAction(this.JOIN_NOW, props<{ chatId: string }>());

  RequestJoin = createAction(this.REQUEST_JOIN, props<{ payload: string }>());

  ResponseSuccessJoin = createAction(
    this.RESPONSE_SUCCESS_JOIN,
    props<{ payload: ChatParticipantDto }>()
  );
  ResponseFailJoin = createAction(this.RESPONSE_FAIL_JOIN, props<{ id: string; error: any }>());

  RequestEnd = createAction(this.REQUEST_END, props<{ chatId: string }>());

  ResponseSuccessEnd = createAction(this.RESPONSE_SUCCESS_END, props<{ payload: ChatDto }>());
  ResponseFailEnd = createAction(this.RESPONSE_FAIL_END, props<{ id: string; error: any }>());

  NotifyNewChatAvailable = createAction(this.NOTIFY_NEW_CHAT_AVAILABLE, props<{ chat: ChatDto }>());

  constructor() {
    super(`Chats`);
  }
}

export const Chats = new ChatActions();
